const authLocalStorageKey = 'embraceable-ai-auth';
const uiSettingsLocalStorageKey = 'embraceable-ai-settings-ui';
const tourLocalStorageKey = 'embraceable-ai-tour';

export const localStorageKeys = {
  auth: authLocalStorageKey,
  uiSettings: uiSettingsLocalStorageKey,
  tour: tourLocalStorageKey,
};
